import { DeliveryProfileSchema } from "@redotech/redo-shopify-common/delivery-profile";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export enum GetAllDeliveryProfilesResult {
  SUCCESS = "SUCCESS",
  ERROR__GRAPHQL_ACCESS_DENIED = "ERROR__GRAPHQL_ACCESS_DENIED",
  NOT_FOUND = "NOT_FOUND",
}

export const getAllDeliveryProfiles = {
  name: "getAllDeliveryProfiles" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.union([
    z.object({
      deliveryProfiles: z.array(DeliveryProfileSchema),
      result: z.literal(GetAllDeliveryProfilesResult.SUCCESS),
    }),
    z.object({
      result: z.union([
        z.literal(GetAllDeliveryProfilesResult.ERROR__GRAPHQL_ACCESS_DENIED),
        z.literal(GetAllDeliveryProfilesResult.NOT_FOUND),
      ]),
    }),
  ]),
};

export type GetAllDeliveryProfilesOutput = z.infer<
  typeof getAllDeliveryProfiles.output
>;
